import { CheckboxGroup, CheckboxOption, Popover, PopoverContent, PopoverTrigger } from '@ibsys/kit';
import { IconButton } from '../IconButton';
import { Settings2Icon } from 'lucide-react';
import { FC } from 'react';

type Props = {
  /** Заголовок окна; он же — доступное имя кнопки-триггера */
  title: string;
  /** Имя группы чекбоксов */
  name: string;
  /** Опции отбора */
  options: CheckboxOption[];
  /** Отмеченные значения */
  value: string[];
  onChange: (values: string[]) => void;
};

/**
 * Кнопка-шестерёнка с окном отметок — оболочка настройки, отмечаемой чекбоксами.
 *
 * Единственное место, где задан вид такой настройки (иконка, размеры окна, раскладка отметок):
 * состав опций и правила сведения выбора остаются у потребителя, а оформление не расходится
 * между настройками разных секций.
 */
export const CheckboxSettingsPopover: FC<Props> = ({ title, name, options, value, onChange }) => (
  <Popover>
    <IconButton size="icon" icon={<Settings2Icon className="size-4" />} label={title} trigger={PopoverTrigger} />
    <PopoverContent className="w-64" align="end">
      <p className="mb-3 text-sm font-medium">{title}</p>
      <CheckboxGroup name={name} options={options} value={value} onChange={onChange} className="flex flex-col gap-2" />
    </PopoverContent>
  </Popover>
);
